export default "__VITE_ASSET__JeaxsJ_$__"